import { createShareConfigFormData as createFormData } from '@/form/form-data';
export const initState = () => ({
    // 최초 등록인지 판단 여부
    isConfigBefore: false,
    formData: createFormData(),
    originFormData: createFormData(),
    selectedShareHubId: '',
    // 공유 정보 설정 값
    shareInfoConfig: null,
    totalSubscribeHubStoreList: [],
    subscribeHubStoreInfo: {
        list: [],
        checkedList: [],
        searchOption: {
            field: 'storeName',
            value: '',
        },
    },
    registeredShareStoreInfo: {
        list: [],
        checkedList: [],
        searchOption: {
            field: 'storeName',
            value: '',
        },
    },
});
const state = initState();
export default state;
